var script = {
  name: 'IconWrapper',
  props: {
    size: {
      type: String,
      default: 'medium'
    },
    primaryColor: {
      type: String,
      default: 'currentcolor'
    },
    secondaryColor: {
      type: String,
      default: '#fff'
    }
  },

  render(h) {
    return h('span', {
      style: {
        color: this.primaryColor,
        fill: this.secondaryColor
      },
      attrs: {
        size: this.size
      },
      on: { ...this.$listeners
      }
    }, [this.$slots.default]);
  }

};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Icon/IconWrapper.vue_rollup-plugin-vue=script.js